export const OTP_DIGITS_REGEX = /^\d*$/
export const OTP_NON_DIGITS_REGEX = /\D/g
export const OTP_LENGTH = 6
export const OTP_BASE_CLASS =
  'aspect-square min-w-0 max-w-12 flex-1 rounded border-neutral-100 bg-white text-center text-lg text-neutral-900 transition placeholder:text-neutral-100 focus:border-indigo-300 focus:bg-indigo-50 disabled:cursor-not-allowed disabled:bg-neutral-50'
export const OTP_FILLED_CLASS = 'border-neutral-300'
